@if(menuModules$ | async; as menuModules)  {
    @if (!hidden) {
        <div class="nav-menu flex-row flex-100">
            <div class="nav-menu__content flex-display" [class.isClosed]="isCollapsed">
                <div class="nav-menu__list flex-col space-between flex-100">
                    <div class="nav-menu__list__modules">
                        <div class="nav-menu__header justify-center items-center">
                            @if (domain === 'AYA' && isCollapsed) {
                            <img priority class="small-logo" ngSrc="assets/images/svg/aya-logomark-white.svg" width="40" height="37" alt="aya white logo collapsed menu">
                            }
                            @if (domain === 'AYA' && !isCollapsed) {
                            <img priority class="main-logo" ngSrc="assets/images/svg/aya-primary-white.svg" width="142" height="59" alt="aya white logo menu not collapsed">
                            }
                            @if (domain === 'HCS' && isCollapsed) {
                            <img ngSrc="assets/images/svg/HS_icon_white.svg" alt="healthcare select white icon" width="30">
                            }
                            @if (domain === 'HCS' && !isCollapsed) {
                            <img ngSrc="assets/images/svg/HS_logo_white.svg" alt="healthcare select white logo" width="148">
                            }
                        </div>
                        <mat-nav-list>
                            @if (showInAppNotifications) {
                            <mat-list-item class="nav-menu__list-item" (click)="openModule(moduleTypes.IN_APP_NOTIFICATIONS)"
                                [class.nav-menu__list-item--module-active]="moduleIsClicked === moduleTypes.IN_APP_NOTIFICATIONS">
                                <button mat-icon-button class="bell" [class.collapsed]="isCollapsed && unreadMessagesCount">
                                    <mat-icon>notifications</mat-icon>
                                    @if (isCollapsed && unreadMessagesCount) {
                                    <span class="badge-notification">{{unreadMessagesCount > 50 ? '50+' :
                                        unreadMessagesCount}}</span>
                                    }
                                    @if (!isCollapsed) {
                                    <span class="nav-menu__link__text">Notifications</span>
                                    }
                                    @if (!isCollapsed && unreadMessagesCount) {
                                    <div class="badge">
                                        <span class="badge-notification">{{unreadMessagesCount > 50 ? '50+' :
                                            unreadMessagesCount}}</span>
                                    </div>
                                    }
                                </button>
                            </mat-list-item>
                            }
                            @for (item of menuModules; track item.name) {
                            <div [style.position]="'relative'">
                                <nova-nav-menu-link [linkData]="item" [isCollapsed]="isCollapsed" [dealAlert]="dealAlert"
                                    [isOpen]="item.name === openedModule" [isActive]="item.name === activeModule"
                                    [activeModuleItem]="activeModuleItem" (moduleClick)="openModule(item.name)">
                                </nova-nav-menu-link>
                            </div>
                            }
                        </mat-nav-list>
                    </div>
                    @if (isLoggedIn) {
                    <div class="nav-menu__list__footer">
                        <div class="nav-menu__list-version">
                            <nova-version></nova-version>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div class="nav-menu__toggle flex-row justify-center items-center flex-18-px" (click)="toggleSidebar()">
                <mat-icon [class.isToggled]="isCollapsed">chevron_left</mat-icon>
            </div>
        </div>
    }
}